import * as signalR from "@microsoft/signalr";
import router from "@/router";
import { Message, Notification } from "element-ui";

const notification = document.getElementById("notification");

const state = {
  loading: false,
  connection: null,
  hubUrl: process.env.VUE_APP_BASEURL + "/internalChat",
  internalChatRoomData: [],
  messageCenter: null,
  replyMessage: null,
};

const actions = {
  stopConnection({ commit }) {
    state.connection.stop().then(() => {
      // console.log('connection stop.');
    });
    commit("cleanConnection");
  },
  initConnection({ state, dispatch }, payload) {
    // console.log("1. 初始化 internalChat 連線(new signalR)");
    state.connection = new signalR.HubConnectionBuilder()
      .withUrl(state.hubUrl, {
        accessTokenFactory: () => localStorage.getItem("AC_token"),
      })
      .build();
    dispatch("startConnection");
  },
  startConnection({ state, dispatch }) {
    state.connection
      .start()
      .then(function() {
        dispatch("onReady");
        // console.log("2. internalChat connection onReady");
      })
      .catch((error) => {
        // console.log("(連線錯誤)Error establishing the connection: ", error);
      });
  },
  // on listen
  onReady({ rootState, state, dispatch, commit }) {
    state.connection.on("onError", function(message) {
      // console.log('connection onError', message);
      Message({
        message: message,
        center: true,
        iconClass: "el-icon-circle-close",
        customClass: "msg msg-error",
        duration: 5000,
        showClose: true,
      });
    });
    // LoadInternalChatRoom
    state.connection.on("LoadInternalChatRoom", function(data) {
      commit("setInternalChatRoom", data);
    });
    // LoadMessageCenter
    state.connection.on("LoadMessageCenter", function(data) {
      commit("global/setMessageCenter", data, { root: true });
    });
    // updateMessageCenter
    state.connection.on("updateMessageCenter", function(data) {
      // console.log('on updateMessageCenter', data);
      if (data.type == "Notification") {
        Notification({
          title: "通知中心",
          message: data.message || "您收到了一則新通知。",
          iconClass: "el-icon-message-solid",
        });
      }

      dispatch("global/receiveMessage", data, { root: true });
    });
    // inviteRoom
    state.connection.on("inviteRoom", function(data) {
      // console.log('收到房間邀請', data);
      dispatch("global/receiveMessage", data, { root: true });
    });
    // newMessage
    state.connection.on("newMessage", function(data) {
      // console.log("你收到新訊息:", data);
      let type = data.type;
      let roomId = data.roomId.toString();
      let currentRoomId = router.currentRoute.params.id;
      let isMe = rootState.account.AC_userdata.username == data.user.username;

      if (type !== "System" && !isMe) {
        // 播放聲音訊息
        notification.pause();
        notification.currentTime = 0;
        notification.play();
      }

      if (roomId == currentRoomId) {
        let readMessageData = { internalChatRoomId: roomId };
        // console.log('您剛好在同房間內收到對方訊息 ReadMessage');
        dispatch("readMessage", readMessageData);
        data.isRead = true;
      }
      commit("updateMessage", data);
    });
    // unsendMessage
    state.connection.on("unsendMessage", function(data) {
      commit("removeMessage", data);
    });
    // onLeaveRoom
    state.connection.on("newRoom", function(data) {
      // console.log("有人建立聊天室", data);
      router.push(`/chats/internal/${data.id}`);
      commit("addNewInternalChatRoom", data);
    });
    // onLeaveRoom
    state.connection.on("leaveRoom", function(data) {
      // console.log("自動將此房間從自己前端的聊天室陣列中移除", data);
      commit("leaveInternalChatRoom", data);
    });
    // removeLeaveRoomUser
    state.connection.on("removeLeaveRoomUser", function(data) {
      // console.log("有人離開聊天室了:", data);
      commit("removeLeaveRoomUser", data);
    });
    // roomAddUser
    state.connection.on("roomAddUser", function(data) {
      // console.log("有人被邀請了:", data);
      commit("addRoomUser", data);
    });
    state.connection.on("readMessage", function(data) {
      // console.log("你讀訊息了:", data);
      commit("readRoomMessage", data);
    });
  },
  // invoke
  sendNewMessage({ state, commit }, payload) {
    let uuid = new Date().getTime().toString();
    let data = {
      replyId: state.replyMessage ? state.replyMessage.id : null,
      uuid: uuid,
      status: "0",
      ...payload,
    };
    commit("setReplyMessage", null); // clean replyMessage
    state.connection.invoke("SendNewMessage", data);
  },
  unsendNewMessage({ state }, payload) {
    state.connection.invoke("UnsendMessage", payload);
  },
  createNewInternalRoom({ state }, payload) {
    state.connection.invoke("CreateNewRoom", payload);
  },
  leaveRoom({ state }, payload) {
    state.connection.invoke("LeaveRoom", payload);
  },
  invite({ state }, payload) {
    state.connection.invoke("InviteUsersToRoom", payload);
  },
  replyRoomInvite({ state }, payload) {
    state.connection.invoke("ReplyRoomInvite", payload);
    // console.log('replyRoomInvite', payload);
  },
  readMessage({ state }, payload) {
    if (state.connection.state === "Connected") {
      state.connection.invoke("ReadMessage", payload);
    }
  },
};
const mutations = {
  setLoading(state, payload) {
    state.loading = payload;
  },
  cleanConnection(state) {
    state.connection = null;
    state.internalChatRoomData = null;
  },
  // 初始化聊天室
  setInternalChatRoom(state, payload) {
    state.internalChatRoomData = payload;
  },

  // 將此房間從自己前端的聊天室物件陣列中移除
  leaveInternalChatRoom(state, payload) {
    state.internalChatRoomData.forEach((room, i) => {
      if (room.id == payload) {
        state.internalChatRoomData.splice(i, 1);
        return;
      }
    });
  },
  removeMessage(state, payload) {
    state.internalChatRoomData.forEach((el, i) => {
      if (el.id == payload.roomId) {
        state.internalChatRoomData[i].messages.forEach((m, mi) => {
          if (m.id == payload.messageId) {
            state.internalChatRoomData[i].messages[mi].isHidden = true;
            return;
          }
        });
        return;
      }
    });
  },
  // 通知群組其他人在此房間中移除自己
  removeLeaveRoomUser(state, payload) {
    state.internalChatRoomData.forEach((el, i) => {
      if (el.id == payload.internalChatRoomId) {
        state.internalChatRoomData[i].users.forEach((u, ui) => {
          if (u.username == payload.username) {
            state.internalChatRoomData[i].users.splice(ui, 1);
            return;
          }
        });
        return;
      }
    });
  },
  // 偵聽新增聊天至
  addNewInternalChatRoom(state, payload) {
    state.internalChatRoomData.push(payload);
  },
  updateMessage(state, payload) {
    state.internalChatRoomData.forEach((el, i) => {
      if (el.id == payload.roomId) {
        state.internalChatRoomData[i].messages.push(payload);
      }
    });
  },
  addRoomUser(state, payload) {
    state.internalChatRoomData.forEach((el, i) => {
      if (el.id == payload.roomId) {
        state.internalChatRoomData[i].users.push(payload.addUser);
        return;
      }
    });
  },
  readRoomMessage(state, payload) {
    state.internalChatRoomData.forEach((el, i) => {
      if (el.id == payload.roomId) {
        state.internalChatRoomData[i].messages.forEach((m) => {
          m.isRead = true;
          return;
        });
        return;
      }
    });
  },
  setReplyMessage(state, payload) {
    state.replyMessage = payload;
  },
};
const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
